<template>
<ul v-if="pony" class="item-stats">
  <li class="item-stat">
    <span class="item-stat-label">Collected: </span>
    <span class="item-stat-value">{{pony.collected}}</span>
  </li>
  <li class="item-stat">
    <span class="item-stat-label">Wishlisted: </span>
    <span class="item-stat-value">{{pony.wishlisted}}</span>
  </li>
  <li class="item-stat">
    <span class="item-stat-label">Favorited: </span>
    <span class="item-stat-value">{{pony.favorited}}</span>
  </li>
</ul>
</template>

<script>
export default {
  name: 'PonyStats',
  props: {
    pony: {
      type: Object,
      required: true
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.item-stats {
  border-top: 1px solid $accent-color;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
}

.elr-card-body .item-stats {
  border-top: 0;
  padding-top: 0;
  border-bottom: 1px solid #ccc;
}

.item-stat {
  font-size: 14px;
  padding-right: 0;
  flex: 1;
}
</style>

